var map = {
	"./anxiang/bg.png": "wyRq",
	"./default/bg.png": "HVBc",
	"./huarong/bg.png": "2LcX",
	"./master/bg.png": "3t3A",
	"./shaodong/bg.png": "wUNl",
	"./taoyuan/bg.png": "L/ze",
	"./yueyang/bg.png": "SqsX",
	"./zhuzhou/bg.png": "XECD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DbWL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/bg\.png$
// module id = DbWL
// module chunks = 1